import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

type BadgeVariants = "secondary" | "success" | "failed" | "pending" | "primary" | "default";

const badgeVariants = cva(
    "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                primary: "border-transparent bg-primary text-primary-foreground shadow",
                secondary: "border-transparent bg-secondary text-secondary-foreground",

                failed: "border-transparent bg-destructive text-white",
                //success: "border-transparent bg-emerald-500 text-white",
                success: "border-transparent bg-emerald-100 text-emerald-950",
                pending: "border-transparent bg-slate-200 text-slate-950",
            },
        },
        defaultVariants: {
            variant: "primary",
        },
    },
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants, BadgeVariants };
